export default __webpack_public_path__ + "static/media/halas14.a919831d.jpg";